import { render, staticRenderFns } from "./ReinviteDialog.vue?vue&type=template&id=120d66c2&"
import script from "./ReinviteDialog.vue?vue&type=script&lang=js&"
export * from "./ReinviteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports